import React from "react";
import EmailMessageForm from "../../../forms/emails/EmailMessageForm";
import { ClientReportType } from "../../../../types/ClientReportType";
import { useForm } from "react-hook-form";
import { useAuth } from "react-oidc-context";
import { toNString } from "../../../../helpers/guids";
import moment from "moment";

export type EmailSendOptionsFormProps = {
    onEmailFormChanged: (form: MailMessage) => void,
    report: ClientReportType
};

export const EmailSendOptionsForm = (
    { onEmailFormChanged, report } : Readonly<EmailSendOptionsFormProps>
) => {
    const { user } = useAuth();
    const reportAttachments : MailMessageAttachment[] = React.useMemo(() => {
        let attachments: MailMessageAttachment[] = [
            {
                id: report.id,
                file: null,
                documentId: report.id, // NOTE: at this point there is not pdf of the report
                type: 'GraphDocument',
                name: `${report.reportName}.pdf`,
                size: 0,
                fileType: 4,
                lastModified: moment().valueOf(),
                password: '{{__DEFAULT__}}',
                __isLocked__: true
            }
        ];

        if (report.businessSheet) {
            attachments.push({
                id: report.businessSheet.businessSheetId,
                file: null,
                documentId: report.businessSheet.pdfUnSignedDocumentId ?? report.businessSheet.businessSheetId,
                type: 'GraphDocument',
                name: `${report.reportName} (Business Sheet).pdf`, // TODO: Check the naming convention here
                size: 0,
                fileType: 4,
                lastModified: moment().valueOf(),
                password: '{{__DEFAULT__}}',
                __isLocked__: true
            })
        }

        return attachments;
    }, [ report ]);

    const formMethods = useForm<MailMessage>({ defaultValues: { 
        masterAccountId: report.masterAccountId,
        projectId: report.projectId,
        subject: '',
        body: '',
        attachments: reportAttachments,
        from: toNString(user?.profile.sub),
        toRecipients: [],
        ccRecipients: [],
        bccRecipients: []
    }});
    
    const formContents = formMethods.watch();

    // whenever the form is changed from within the generic email form component,
    // then we can trigger the parent update, which modifies the overall send/patch object.
    React.useEffect(() => onEmailFormChanged(formContents), [ formContents ]);

    return <EmailMessageForm
        defaultValues={formContents}
        isDocumentSelectorShown={true}
        isFileProtectionEnabled={true}
        {...formMethods}
    />
};